import {
  ChangeDetectionStrategy,
  Component,
  AfterViewInit,
  ViewChildren,
  QueryList,
  ElementRef,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SubstackService } from '../../../core/services/substack.service';

@Component({
  selector: 'app-newsletter',
  imports: [CarouselModule, CommonModule, HttpClientModule],
  templateUrl: './newsletter.html',
  styleUrl: './newsletter.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Newsletter implements OnInit {

  newsletters: any[] = [];
  loading = true;
  error = false;

  responsiveOptions = [
    {
      breakpoint: '1400px',
      numVisible: 3,
      numScroll: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  constructor(
    private substackService: SubstackService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.loadPosts();
  }

  loadPosts() {
    this.loading = true;
    this.error = false;
    this.newsletters = [];

    this.substackService.getPosts().subscribe({
      next: (posts) => {
        this.newsletters = posts;
        this.loading = false;
        this.error = false;
        this.cdRef.detectChanges();
      },
      error: () => {
        this.loading = false;
        this.error = true;
        this.newsletters = [];
        this.cdRef.detectChanges();
      }
    });
  }

  retryLoadPosts() {
    this.loadPosts();
  }
}
